var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemberConfirmBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 82,
    viewBox: "0 0 768 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1101_28817)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.169 -5.58154L238.955 11.3871L229.169 28.3557L209.596 28.3557L199.72 11.3871L209.596 -5.58154L229.169 -5.58154Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.169 36.9746L238.955 53.9432L229.169 70.9118L209.596 70.9118L199.72 53.9432L209.596 36.9746L229.169 36.9746Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.628 16.0557L202.414 33.0243L192.628 49.9929L172.966 49.9929L163.18 33.0243L172.966 16.0557L192.628 16.0557Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.811 -5.58154L659.597 11.3871L649.811 28.3557L630.239 28.3557L620.363 11.3871L630.239 -5.58154L649.811 -5.58154Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.811 36.9746L659.597 53.9432L649.811 70.9118L630.239 70.9118L620.363 53.9432L630.239 36.9746L649.811 36.9746Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M744.171 11.1172L753.957 28.0858L744.171 45.0544L724.599 45.0544L714.723 28.0858L724.599 11.1172L744.171 11.1172Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.448 22.7896L558.234 39.7582L548.448 56.7268L528.876 56.7268L519 39.7582L528.876 22.7895L548.448 22.7896Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.27 16.0557L623.056 33.0243L613.27 49.9929L593.608 49.9929L583.822 33.0243L593.608 16.0557L613.27 16.0557Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1101_28817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberConfirmBg);
export default __webpack_public_path__ + "static/media/member-confirm-bg.62e25ebf16559f7b58ff47eff7bb21fe.svg";
export { ForwardRef as ReactComponent };